/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
import i from"./PointSizeAlgorithm.js";import t from"./PointSizeFixedSizeAlgorithm.js";import o from"./PointSizeSplatAlgorithm.js";const e={key:"type",base:i,typeMap:{"fixed-size":t,splat:o}};export{e as pointSizeAlgorithmTypes};
